import axios from 'axios'
import getNodeMiddlewareUrl from './getNodeMiddlewareUrl'
import PATHS from '../../client/router/routesMap'
import store from '../../client/store'
import JSONbig from 'true-json-bigint'

const axiosCommon = axios.create({
  baseURL: getNodeMiddlewareUrl(),
  withCredentials: true,
  timeout: 300000
})

/**
 * :CancelamentoRequisicao
 * Essas funções tem o objetivo de cancelar as requisições em andamento (caso sejam requisições demoradas, por exemplo).
 * Motivo que provocou essa adição é que na tela incial (dashbord/gadgets), a consulta do saldo bancário pode ser demorada, com isso, a troca de clientes pelo usuário
 * irá fazer com que quando a consulta do saldo bancário terminasse, ele mostraria o saldo no cliente errado, o que iria trazer confusão.
 *
 * @see https://equals.atlassian.net/browse/BK-787
 * @see https://github.com/inflexiontecnologia/interno-equals-conciliacaobancaria/blob/bce03f862eaf91d7b47ac4d994046de4020da211/frontend/client/store/modules/dashboard.js#L165
 * @see https://github.com/inflexiontecnologia/interno-equals-conciliacaobancaria/blob/bce03f862eaf91d7b47ac4d994046de4020da211/frontend/client/store/modules/dashboard.js#L296
 *
 **/
axiosCommon.CancelToken = axios.CancelToken
axiosCommon.isCancel = axios.isCancel

axiosCommon.interceptors.request.use((config) => {
  config.headers = { 'x-access-token': localStorage.getItem('token') }
  config.transformResponse = data => {
    if (typeof data === 'string') {
      try {
        data = JSONbig.parse(data) // gera uma conversão maior que os 53bits default do JavaScript
      } catch (e) {
        /* Ignore */
      }
    }
    return data
  }
  return config
}, (error) => {
  return Promise.reject(error)
})

axiosCommon.interceptors.response.use(
  res => {
    if (res.headers['x-access-token']) {
      localStorage.setItem('token', res.headers['x-access-token'])
    }

    if (localStorage.getItem('CONNECTION_ERROR')) {
      localStorage.removeItem('CONNECTION_ERROR')
    }

    return Promise.resolve(res)
  },
  error => {
    if (error instanceof axios.Cancel) {
      error.message = 'user.cancelled'
      return Promise.reject(error)
    }
    if (error && error.message === 'Network Error') {
      store.dispatch('cleanVuexModules')
      localStorage.setItem('CONNECTION_ERROR', true)
      if (location.pathname !== PATHS.LOGIN) {
        location.href = PATHS.LOGIN
      }
      return Promise.reject(res)
    }
    let res = error.response
    if (!res || res.status === 401) {
      store.dispatch('cleanVuexModules').then(() => {
        store.dispatch('logout').then(() => {
          location.href = PATHS.LOGIN
          localStorage.setItem('SESSION_ERR', 'naoAutorizado.labels.mensagem401')
        })
      })
      return Promise.reject(res)
    }
    if (res.status === 403) {
      location.href = PATHS.UNAUTHORIZED
      return Promise.reject(res)
    }
    if (!(res.status >= 200 && res.status < 400)) {
      return Promise.reject(res.data)
    }
  }
)

export default axiosCommon



// WEBPACK FOOTER //
// ./build/http-requests/axios-common.js